import Vue from 'vue'
import {
  Loading,

  Footer,
  Menu,
  Submenu,
  MenuItem,
  Backtop,
  Image,

  Container,
  Header,
  Aside,
  Main,
  Message,
  Form,
  FormItem,
  Input,
  InputNumber,
  Button,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Select,
  Option,
  Switch,
  Carousel,
  CarouselItem,
  Tabs,
  TabPane,
  Empty,
  Tooltip,
  Popover,
  Divider,
  Table,
  TableColumn,
  Dialog,
  Col,
  DatePicker,
  TimePicker,
  ColorPicker,
  Upload
} from 'element-ui'
Vue.use(Loading.directive)

Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Select)
Vue.use(Option)
Vue.use(Switch)

Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.use(Tabs)
Vue.use(TabPane)

Vue.use(Empty)

Vue.use(Tooltip)
Vue.use(Popover)

Vue.use(Divider)

Vue.use(Table)
Vue.use(TableColumn)

Vue.use(Dialog)

Vue.use(Col)

Vue.use(DatePicker)
Vue.use(TimePicker)

Vue.use(ColorPicker)

Vue.use(Upload)

Vue.use(Image)

Vue.use(Footer)

Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)

Vue.use(Backtop)

Vue.prototype.$message = Message